import { mutate } from 'swr';

import { CreditHelpers } from 'helpers/CreditHelpers';

const CreditService = {
    refreshCreditBalanceDetails: (teamId: string) => {
        return mutate(CreditHelpers.swr.creditBalanceDetails(teamId));
    },
};

export { CreditService };
